import React, { useEffect, useRef, useState } from 'react';
import "./homepagecomponents.css"


const HomepageComp4 = () => {



    const ref = useRef();
    const [isVisible, setIsVisible] = useState(false);

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.unobserve(entry.target);
            }
        });
    });

    useEffect(() => {
        const currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [ref]);

    return (
        <div className={`homepage-component-container homepage-comp4-container  ${isVisible ? 'fade-in' : ''}`} ref={ref}>

            <div className='grid grid-cols-2 gap-8 px-8'>
                <div>
                    <h1 className='homepage-title2'>Transforming Gold Mining with Merge Turk Gold</h1>
                    <p className='homepage-text3'>Experience gold mining that harmonizes with nature, leveraging modern technology for sustainable practices.</p>
                    <ul className='homepage-text3 list-disc pl-8'>
                        <li>Eco-Friendly Operations - Our commitment to the environment drives us to innovate and minimize our ecological footprint while extracting gold.</li>
                        <li>Advanced Technology - Utilizing the latest machinery and processes ensures efficient gold recovery while prioritizing safety.</li>
                        <li>
                            Community-Focused - We believe in empowering local communities by creating jobs and fostering economic growth through responsible mining practices.</li>
                    </ul>
                    <p className='homepage-text3'>Join us in leading the charge for a greener future in gold mining, where technology meets sustainability for a better tomorrow.</p>
                </div>
                <div>
                    <div className='homepage-img5'></div>
                </div>
            </div>

        </div>
    )
}

export default HomepageComp4